import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  tagWrapper: {
    position: "absolute",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transform: "translateX(-50%) translateY(-50%)",
    transformOrigin: "top left",
    zIndex: "3",
    cursor: "pointer",
    transition: "all .1s",

    //Hide tag because it is already included in video/image
    opacity: 0,
  },
};
